/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from 'react';
// react component that copies the given text inside your clipboard
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Route,
  Redirect,
  useHistory,
  BrowserRouter,
  Switch,
  NavLink as NavLinkRRD,
  Link,
} from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
// reactstrap components

import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Modal,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from 'reactstrap';
import { chartOptions, parseOptions, chartExample2 } from 'variables/charts.js';
import { Line, Bar } from 'react-chartjs-2';
import Chart from 'chart.js';
import axiosInstance from '../../helpers/axiosInstance';
import ReactCircleModal from 'react-circle-modal';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import Slicer from 'react-slicer';
import 'react-slicer/build/react-slicer.css';
import Paginador from './paginador';
import { useDispatch } from 'react-redux';
import {
  cambiaruta,
  cambiasidebar,
  desactivasidebar,
  actulizaInitHome,
} from '../../Slicersreducers';

const BasicData = (props) => {
  const convierteFecha = (fecha) => {
    let newFecha = fecha;
    let fecha400 = '';
    if (newFecha.getMonth() + 1 < 10) {
      fecha400 =
        newFecha.getFullYear() + '0' + (newFecha.getMonth() + 1) + fecha400;
    } else {
      fecha400 =
        newFecha.getFullYear() + '' + (newFecha.getMonth() + 1) + fecha400;
    }
    if (newFecha.getDate() < 10) {
      fecha400 = fecha400 + '0' + newFecha.getDate();
    } else {
      fecha400 = fecha400 + newFecha.getDate();
    }
    return fecha400;
  };
  const periodoGrafica = () => {
    let diasSemana = [
      'Domingo',
      'Lunes',
      'Martes',
      'Miercoles',
      'Jueves',
      'Viernes',
      'Sabado',
    ];
    let meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    let periodo =
      'Del ' +
      diasSemana[newFechaI.getDay()] +
      ', ' +
      newFechaI.getDate() +
      ' de ' +
      meses[newFechaI.getMonth()] +
      ' del ' +
      newFechaI.getFullYear() +
      '. al ' +
      diasSemana[newFechaF.getDay()] +
      ', ' +
      newFechaF.getDate() +
      ' de ' +
      meses[newFechaF.getMonth()] +
      ' del ' +
      newFechaF.getFullYear();
    return periodo;
  };

  const [investmentValue, setInvestmentValue] = useState(0);
  const [timeLimit, setTimeLimit] = useState(0);
  const [product, setProduct] = useState(0);
  const [openingDate, setOpeningDate] = useState(0);
  const [closingDate, setClosingDate] = useState(0);
  const [state, setState] = useState(0);
  const [rate, setRate] = useState(0);
  const [accruedInterest, setAccruedInterest] = useState(0);
  const [interestDue, setInterestDue] = useState(0);
  const [interestPaid, setInterestPaid] = useState(0);

  const [MovCuenta, setMovCuenta] = useState([]);
  const [newFechaI, setnewFechaI] = useState(new Date());
  const [newFechaF, setnewFechaF] = useState(new Date());
  const [entradasCuenta, setentradasCuenta] = useState(0);
  const [salidasCuenta, setsalidasCuenta] = useState(0);
  const [estiloTrans, setestiloTrans] = useState([]);
  const [perGraf, setperGraf] = useState(periodoGrafica());
  const [barras, setbarras] = useState(['0%', '0%']);
  const [cargando, setcargando] = useState(false);
  const [muestramodal, setmuestramodal] = useState(false);
  const dispatch = useDispatch();

  const buscaMov = async () => {
    const entradaMovimientos = {
      accountNumber: props.accountNumber,
      productType: '6',
      page: 'I000203',
      parameters: [
        props.accountNumber,
        convierteFecha(newFechaI),
        convierteFecha(newFechaF),
      ],
    };
    console.log(entradaMovimientos);
    const apiUrlMov = '/WSGYG39_2/api/Inquiries/CdtMovements';
    const resmov = await axiosInstance()
      .post(apiUrlMov, entradaMovimientos)
      .catch((err) => {
        setMovCuenta([]);
        //alert("Hay un problema. Vuelve atras CDTs");
      });
    if (resmov != 'err') {
      console.log(resmov.data.transactionHistory);
      if (resmov.data.transactionHistory.length > 0) {
        let entradas = 0;
        let salidas = 0;
        let estilo = [];
        let valorProv;
        for (let i = 0; i < resmov.data.transactionHistory.length; i++) {
          valorProv = parseFloat(
            resmov.data.transactionHistory[i].transactionBalance.replace(
              ',',
              ''
            )
          );
          if (valorProv >= 0) {
            estilo.push('green');
            entradas += valorProv;
          } else {
            estilo.push('red');
            salidas += valorProv;
          }
        }
        if (entradas > -1 * salidas) {
          setbarras(['100%', ((-1 * salidas) / entradas) * 100 + '%']);
        } else {
          setbarras([(entradas / (-1 * salidas)) * 100 + '%', '100%']);
        }
        console.log('ajuste: ' + entradas);
        setentradasCuenta(Math.round(entradas * 100) / 100);
        setsalidasCuenta(Math.round(salidas * 100) / 100);
        setestiloTrans(estilo);
        setperGraf(periodoGrafica());
      }
      setMovCuenta(resmov.data.transactionHistory);
    }
  };

  useEffect(async () => {
    dispatch(cambiaruta('Inicio/Detalle CDT'));
    dispatch(cambiasidebar(false));
    dispatch(desactivasidebar());
    dispatch(actulizaInitHome(false));

    setcargando(true);
    setmuestramodal(true);
    const apiUrl = '/WSGYG39_2/api/Inquiries/CdtDetails/' + props.accountNumber;
    const res = await axiosInstance()
      .get(apiUrl)
      .catch((err) => {
        //alert("Hay un problema. Vuelve atras");
      });
    if (res != 'err') {
      let saldo = 0;

      /* for(let i=0;i<res.data.summaryProducts.products.length;i++){
                if(res.data.summaryProducts.products[i].accountNumber==props.accountNumber){
                    saldo=res.data.summaryProducts.products[i].balance;
                }
            }*/
      setcargando(false);
      setmuestramodal(false);
      setInvestmentValue(res.data.investmentValue);
      setTimeLimit(res.data.timeLimit);
      setProduct(res.data.product);
      setOpeningDate(res.data.openingDate);
      setClosingDate(res.data.closingDate);
      setState(res.data.state);
      setRate(res.data.rate);
      setAccruedInterest(res.data.accruedInterest);
      setInterestDue(res.data.interestDue);
      setInterestPaid(res.data.interestPaid);
    }
    buscaMov();
  }, MovCuenta);
  const [rangoFechas, setrangoFechas] = useState([
    {
      startDate: newFechaI,
      endDate: newFechaF,
      key: 'selection',
    },
  ]);

  const Pruebacomponente = (props) => {
    return (
      <Card
        className="card-transaction-info"
        style={{ padding: 20 + 'px', margin: '5px 0px 15px 0px' }}
      >
        <div className="">
          <Row style={{ alignItems: 'center' }}>
            <div
              className="col-auto mr-3 text-medium-grey"
              style={{ alignItems: 'center' }}
            >
              <p style={{ marginBottom: 0, fontSize: '12px' }}>
                {props.data.transactionDate.substring(0, 4)}
                <br />
                {props.data.transactionDate.substring(5)}
              </p>
            </div>
            <div className="col">
              <Row>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p
                    style={{
                      fontWeight: 700,
                      margin: '2px 0 0 0px',
                      fontSize: '12px',
                    }}
                  >
                    {' '}
                    {props.data.transactionName}
                  </p>
                </div>
              </Row>
              <Row>
                <span
                  style={{ marginBottom: 0, fontWeight: 700, fontSize: '12px' }}
                  class="mb-2 text-sm"
                >
                  CDT No. {props.data.accountNumber}{' '}
                </span>
              </Row>
            </div>
            <div className="col-auto mr-3 vertical-center">
              <h6
                style={{
                  fontWeight: 600,
                  fontSize: 1 + 'rem',
                  marginBottom: 0,
                }}
                className="text-grissantander"
              >
                {' '}
                <i className="fas fa-dollar-sign" />{' '}
                {props.data.transactionBalance}
              </h6>
            </div>
          </Row>
        </div>
      </Card>
    );
  };

  const ListMovimientos = (props) => {
    let listahistorico = [];
    let registroHis = {
      transactionDate: '',
      transactionName: '',
      accountNumber: '',
      transactionBalance: '',
    };
    for (let i = 0; i < props.historicoTransacciones.length; i++) {
      registroHis.transactionDate =
        props.historicoTransacciones[i].transactionDate;
      registroHis.transactionName =
        props.historicoTransacciones[i].transactionName;
      registroHis.accountNumber = props.accountNumber;
      registroHis.transactionBalance =
        props.historicoTransacciones[i].transactionBalance;
      listahistorico.push(JSON.parse(JSON.stringify(registroHis)));
    }
    return (
      <div className="cuerpopaginador">
        <Paginador
          Componentepag={Pruebacomponente}
          datos={listahistorico}
          numitems={5}
          numpag={3}
        ></Paginador>
      </div>
    );

    /*
            return (
                <div className="col-md-12">
                    <Slicer
                        initialPage={1}
                        itemsPerPage={10}
                    >
                        {props.historicoTransacciones.map((item,index)=>{
                            return(
                                <Card className="shadow col-md-12" style={{padding:20+'px', margin: "5px 15px 15px 15px"}} key={index}>
                                    <div className="">
                                        <Row style={{alignItems:"center"}}>
                                            <div className="col-auto mr-3" style={{alignItems:"center"}}>
                                                <p style={{marginBottom:0}}>{item.transactionDate}</p>
                                            </div>
                                            <div className="col">
                                                <Row>
                                                    <div style={{ display: "flex", alignItems: "center", marginLeft: 10 + 'px' }}>
                                                       
                                                        <p style={{ fontWeight: 400, margin: '2px 0 0 5px' }}> {item.transactionName}</p>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <span style={{marginBottom:0}} class="mb-2 text-sm">CDT No. {props.accountNumber} </span>
                                                </Row>
                                            </div>
                                            <div className="col-auto mr-3 vertical-center">
                                                <h6 style={{fontWeight:600, fontSize:1+'rem', marginBottom:0, color:estiloTrans[index]}}>  <i className="fas fa-dollar-sign" /> {item.transactionBalance}</h6>
                                            </div>
                                        </Row>
                                    </div>
                                </Card>
                        )})}
                    </Slicer>
                </div>
                
        
            );
            */
  };
  if (cargando == false) {
    return (
      <div lg="12" xl="12" className="">
        {/* <Link
          className="h6 mb-0 ml-4 text-primary d-none d-lg-inline-block"
          to="/admin/home"
        >
          <img
            className="ml-3"
            src={require('../../assets/img/icons/Flecha Abajo.png').default}
          />
          {'Regresar'}
        </Link> */}

        <h1 style={{ 'padding-left': '52px', fontSize: 1.25 + 'em' }}>
          Detalles del producto
        </h1>
        <Card className="mb-xl-0 bg-transparent pl-5 pr-5 pt-2">
          <div className="bg-white row m-2 ">
            {/*<div class="card-profile-stats d-flex justify-content-init col">*/}
            <div style={{ textAlign: 'left' }} className="col-md-12">
              <Row style={{ marginBottom: 30 + ' px' }}>
                <div
                  className="col-6 bg-white"
                  style={{ 'border-right': '1px solid darkgray' }}
                >
                  <h6
                    className="mb-0 ml-3"
                    style={{
                      fontSize: 1 + 'rem',
                      fontWeight: 500,
                      margin: 10 + 'px',
                      padding: 0 + 'px',
                    }}
                  >
                    {' '}
                    Nombre del producto{' '}
                  </h6>
                  <h5
                    className="ml-3"
                    style={{ fontSize: 1 + 'rem', 'text-indent': 1 + 'px' }}
                  >
                    {product}
                  </h5>
                </div>
                <div className="col-6 bg-white">
                  <h6
                    className="mb-0 ml-3"
                    style={{
                      fontSize: 1 + 'rem',
                      fontWeight: 500,
                      margin: 10 + 'px',
                      padding: 0 + 'px',
                    }}
                  >
                    Número del producto{' '}
                  </h6>
                  <h5
                    className="ml-3"
                    style={{ fontSize: 1 + 'rem', 'text-indent': 1 + 'px' }}
                  >
                    {props.accountNumber}
                  </h5>
                </div>
              </Row>
            </div>
            {/*</div>*/}
            {/*<div class="card-profile-stats d-flex justify-content-center">
                        <div className="">
                            <i className="far fa-file-alt" />
                            <p class="">Extractos y certificados</p>
                        </div>
                        <div>
                            <i className="fas fa-exchange-alt"></i>
                            <p class="">Transferir</p>
                        </div>
                    </div>*/}
          </div>
          <CardBody className="pb-1 row">
            <div className="col-md-12">
              <Row style={{ marginBottom: 30 + ' px' }}>
                <div
                  className="col-6 bg-white"
                  style={{
                    'border-bottom': '1px solid darkgray',
                    'border-right': '1px solid darkgray',
                  }}
                >
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/AB130-money cash dollar _ Dollars, Pesos, Reais, Do╠ülares, Currency, Coin, Moneda, Divisa, Money, Dinero, cash,  efectivo, notes, billetes.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Valor Inversión{' '}
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {investmentValue}
                  </h5>
                </div>

                <div
                  className="col-6 bg-white"
                  style={{ 'border-bottom': '1px solid darkgray' }}
                >
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/AC330-value _ OBJECTS, diamond, diamante ACTIVITIES, value, valor.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      {' '}
                      Estado{' '}
                    </h6>
                  </div>

                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {state}
                  </h5>
                </div>
              </Row>
              <Row style={{ marginBottom: 30 + ' px' }}>
                <div
                  className="col-md-6 bg-white"
                  style={{
                    'border-right': '1px solid darkgray',
                    'border-bottom': '1px solid darkgray',
                  }}
                >
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/BC330-appointments _ DOCUMENTS, calendar, checkmark, ok, appointment, cita, schedule, agenda, reunio╠ün, meeting.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Fecha Apertura{' '}
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {openingDate}
                  </h5>
                </div>
                <div
                  className="col-md-6 bg-white"
                  style={{ 'border-bottom': '1px solid darkgray' }}
                >
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/BC335-cancel-appointments _ DOCUMENTS, calendar, cross, cancel, appointment, cita, schedule, agenda, reunio╠ün, meeting.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Fecha Vencimiento{' '}
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {' '}
                    {closingDate}
                  </h5>
                </div>
              </Row>
              <Row style={{ marginBottom: 30 + 'px' }}>
                {/*<div className="col-md-4">
                                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}> <i className="fas fa-database"/> Producto </h6>
                                <h5 style={{ fontSize: 1.25 + 'rem' }}> {product} </h5>
                            </div>*/}
                <div
                  className="col-md-6 bg-white"
                  style={{ 'border-right': '1px solid darkgray' }}
                >
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/D0410-time _ OBJECTS, clock, watch, reloj ACTIVITIES, time, tiempo.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Plazo{' '}
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {' '}
                    {timeLimit} Días{' '}
                  </h5>
                </div>
                <div className="col-md-6 bg-white">
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/AC070-income tax _ income,  tax, pago, impuestos, percentage.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Tasa{' '}
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {' '}
                    {rate}
                  </h5>
                </div>
              </Row>
              <Row style={{ marginBottom: 30 + 'px' }}>
                <div
                  className="col-md-4 bg-white"
                  style={{ 'border-right': '1px solid darkgray' }}
                >
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/AB130-money cash dollar _ Dollars, Pesos, Reais, Do╠ülares, Currency, Coin, Moneda, Divisa, Money, Dinero, cash,  efectivo, notes, billetes.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Intereses Causados{' '}
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {accruedInterest}
                  </h5>
                </div>
                <div
                  className="col-md-4 bg-white"
                  style={{ 'border-right': '1px solid darkgray' }}
                >
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/AB130-money cash dollar _ Dollars, Pesos, Reais, Do╠ülares, Currency, Coin, Moneda, Divisa, Money, Dinero, cash,  efectivo, notes, billetes.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Intereses Pagados{' '}
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {' '}
                    {interestPaid}
                  </h5>
                </div>
                <div className="col-md-4 bg-white">
                  <div className="inputs-iconsleft pt-2">
                    <div className="icon icon-shape" style={{ height: '0px' }}>
                      <img
                        className=""
                        src={
                          require('../../assets/img/icons/AB130-money cash dollar _ Dollars, Pesos, Reais, Do╠ülares, Currency, Coin, Moneda, Divisa, Money, Dinero, cash,  efectivo, notes, billetes.svg')
                            .default
                        }
                      />
                    </div>
                    <h6
                      style={{
                        fontSize: 1 + 'rem',
                        fontWeight: 500,
                        color: 'darkgray',
                        margin: 0 + 'px',
                        padding: 0 + 'px',
                      }}
                    >
                      Intereses Pendientes de Pago
                    </h6>
                  </div>
                  <h5 style={{ fontSize: 1 + 'rem', textIndent: 55 + 'px' }}>
                    {' '}
                    {interestDue}
                  </h5>
                </div>
              </Row>
            </div>
            {/*<div className="col-md-4">
                        <Row>
                            <div className="col-12">
                                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}> <i className="fas fa-chart-bar text-danger" /> {perGraf} </h6>
                            </div>
                        </Row>
                        <Row>
                            <div _ngcontent-eqv-c27="" class="graphs-body">
                                <div _ngcontent-eqv-c27="" class="drawing">
                                    <span _ngcontent-eqv-c27="" class="rectangle in" style={{height: barras[0]}}></span>
                                    <span _ngcontent-eqv-c27="" class="rectangle out" style={{height: barras[1]}}></span>
                                </div>
                                <div _ngcontent-eqv-c27="" class="info">
                                    <div class="in">
                                        <p _ngcontent-eqv-c27=""> Dinero que entró: </p>
                                        <h6 _ngcontent-eqv-c27="">{entradasCuenta}</h6>
                                    </div>
                                    <div _ngcontent-eqv-c27="">
                                        <p _ngcontent-eqv-c27=""> Dinero que salió: </p><h6 _ngcontent-eqv-c27="">{salidasCuenta}</h6>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </div>*/}
            <div
              className="col-md-12"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
                margin: '24px 15px 10px 0px',
                paddingLeft: '0px',
              }}
            >
              <h4 style={{ fontWeight: 600, fontSize: 1.25 + 'em' }}>
                Mis movimientos
              </h4>
              {/*<div style={{ display: "flex", alignItems: "center" }}>
                            <p style={{ fontWeight: 400, margin: 0 }}> Desde <b>{newFechaI.getDate() + "/" + (newFechaI.getMonth()+1) + "/" + newFechaI.getFullYear()}</b> hasta <b>{newFechaF.getDate() + "/" + (newFechaF.getMonth()+1) + "/" + newFechaF.getFullYear()}</b></p>
                            <div style={{ display: "flex", alignItems: "center", marginLeft: 10 + 'px' }}>

                                
                                <ReactCircleModal
                                    backgroundColor=""
                                    toogleComponent={onClick => (
                                        <button className="btn btn-primary" onClick={onClick}>
                                            <i  className="fas fa-calendar-alt" />
                                        </button>
                                    )}
                                    // Optional fields and their default values
                                    offsetX={'50%'}
                                    offsetY={'50%'}
                                    
                                    >
                                    {(onClick) => (
                                        <div style={{padding: '1em' }}>
                                            <Row>
                                                <DateRangePicker
                                                    onChange={item => {setrangoFechas([item.selection])
                                                    setnewFechaI(item.selection.startDate)
                                                    setnewFechaF(item.selection.endDate)}}
                                                    showSelectionPreview={true}
                                                    moveRangeOnFirstSelection={false}
                                                    months={2}
                                                    ranges={rangoFechas}
                                                    direction="horizontal"
                                                    lang='es'
                                                    />
                                            </Row>
                                            <Row>
                                                <button onClick={onClick} className="btn btn-primary">
                                                    Cerrar calendario
                                                </button>
                                            </Row>
                                        </div>
                                    )}
                                </ReactCircleModal>
                                <button className="btn btn-primary" onClick={buscaMov} style={{margin:'1em'}}> Filtrar</button>
                            </div>
                        </div>*/}
            </div>

            <ListMovimientos
              historicoTransacciones={MovCuenta}
              accountNumber={props.accountNumber}
            ></ListMovimientos>

            {/*
                                <Card className="shadow col-md-12" style={{padding:20+'px', margin: "5px 15px 15px 15px"}}>
                                    <div className="">
                                        <Row style={{alignItems:"center"}}>
                                            <div className="col-auto mr-3" style={{alignItems:"center"}}>
                                                <p style={{marginBottom:0}}>8/4<br/>2021</p>
                                            </div>
                                            <div className="col">
                                                <Row>
                                                    <div style={{ display: "flex", alignItems: "center", marginLeft: 10 + 'px' }}>
                                                        <i className="fas fa-dollar-sign" />
                                                        <p style={{ fontWeight: 400, margin: '2px 0 0 5px' }}> Debito cargo prima bancaseguros alfa cuenta pro internet                               </p>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <span style={{marginBottom:0}} class="mb-2 text-sm">Cuenta de Ahorros No. 702766010</span>
                                                </Row>
                                            </div>
                                            <div className="col-auto mr-3 vertical-center">
                                                <h6 style={{fontWeight:600, fontSize:1+'rem', marginBottom:0}}> - $14.620,<span class="decimal-numbers-format">00</span></h6>
                                            </div>
                                        </Row>
                                    </div>
                                </Card>

                                <Card className="shadow col-md-12" style={{padding:20+'px', margin: "5px 15px 15px 15px"}}>
                                    <div className="">
                                        <Row style={{alignItems:"center"}}>
                                            <div className="col-auto mr-3" style={{alignItems:"center"}}>
                                                <p style={{marginBottom:0}}>8/4<br/>2021</p>
                                            </div>
                                            <div className="col">
                                                <Row>
                                                    <div style={{ display: "flex", alignItems: "center", marginLeft: 10 + 'px' }}>
                                                        <i className="fas fa-dollar-sign" />
                                                        <p style={{ fontWeight: 400, margin: '2px 0 0 5px' }}> Debito cargo prima bancaseguros alfa cuenta pro internet                               </p>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <span style={{marginBottom:0}} class="mb-2 text-sm">Cuenta de Ahorros No. 702766010</span>
                                                </Row>
                                            </div>
                                            <div className="col-auto mr-3 vertical-center">
                                                <h6 style={{fontWeight:600, fontSize:1+'rem', marginBottom:0}}> - $14.620,<span class="decimal-numbers-format">00</span></h6>
                                            </div>
                                        </Row>
                                    </div>
                                </Card>
                            */}
          </CardBody>
        </Card>
      </div>
    );
  } else {
    return (
      <div
        tabindex="-1"
        style={{
          position: 'relative;',
          'z-index': '1050',
          display: 'block',
          width: '100%',
          height: '80vh',
        }}
      >
        <div
          style={{ 'text-align': 'center', top: '50%', position: 'relative' }}
        >
          <img
            style={{ height: '100px' }}
            src={require('../../assets/img/icons/LoaderIDEA.gif').default}
          ></img>
        </div>
        <div class="modal-backdrop fade show"></div>
      </div>
    );
  }
};

const ProductsCard = () => {
  return <></>;
};

const Movements = (props) => {
  console.log(props);
  const [accountNumber, setaccountNumber] = useState(
    props.location.state.accountNumber
  );
  return (
    <>
      <div className="pb-1 pt-1 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <Row>
              <BasicData accountNumber={accountNumber}></BasicData>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Movements;
